import { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Stack, CircularProgress, Alert, Autocomplete
} from "@mui/material";
import { reclamosApi } from "../services/reclamosApi";

export default function ReasignarDialog({
  open,
  onClose,
  reclamoId,
  responsableActualId = null,
  role = "sistemas,tecnico,admin",
  onDone, // (nuevoResponsable) => void  (obj o null)
}) {
  const [usuarios, setUsuarios] = useState([]);
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setError("");
    setUsuarios([]);
    setValue(null);

    (async () => {
      try {
        setLoading(true);
        const usrs = await reclamosApi.usuariosTRS({role});
        
        // Primera opción: Departamento Técnico (bandeja)
        const opts = [{ id: null, nombre: "Departamento Técnico (bandeja)", username: "dep-tecnico" }, ...usrs];
        setUsuarios(opts);

        // Pre-seleccionar el actual si lo conoces (id_responsable guarda el ID numérico, no el username)
        const actual = usrs.find(u => String(u.id) === String(responsableActualId));
        if (actual) setValue(actual);
      } catch (e) {
        setError("No se pudo cargar la lista de responsables.");
      } finally {
        setLoading(false);
      }
    })();
  }, [open, role, responsableActualId]);

  const handleSave = async () => {
    try {
      setSaving(true);
      setError("");
      const id_responsable = value?.id ?? null; // null = Departamento Técnico (bandeja)
      await reclamosApi.reasignar(reclamoId, { id_responsable });
      onDone?.(value); // pasamos el responsable elegido (o null)
    } catch (e) {
      const msg = e?.response?.data?.error || e.message;
      setError(`Error al reasignar: ${msg}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Reasignar responsable</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error && <Alert severity="error">{error}</Alert>}

          <Autocomplete
            loading={loading}
            options={usuarios}
            value={value}
            onChange={(_, v) => setValue(v)}
            getOptionLabel={(o) => (o?.nombre ? o.nombre : (o?.username ?? ""))}
            isOptionEqualToValue={(o, v) => String(o?.id) === String(v?.id)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Responsable"
                placeholder="Busca por nombre o usuario…"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? <CircularProgress size={18} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" onClick={handleSave} disabled={saving || loading}>
          {saving ? "Guardando…" : "Reasignar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
